import React from 'react';
import { useAppState } from '../contexts/AppStateContext';
import { useUi } from '../contexts/UiContext';
import { PageHeader } from '../components/ui/PageHeader';
import { WeekPlanCard } from '../components/progress/WeekPlanCard';
import { AllowanceCard } from '../components/progress/AllowanceCard';
import { GoodiesJarCard } from '../components/progress/GoodiesJarCard';
import { RewardsSection } from '../components/progress/RewardsSection';
import { GoalCard } from '../components/progress/GoalCard';
import { TimeLogSection } from '../components/progress/TimeLogSection';
export function ProgressPage() {
  const {
    isAdmin,
    family,
    viewer
  } = useAppState();
  const {
    openSub
  } = useUi();
  const child = !isAdmin && family.modules.nagrade;
  return <div data-id="element-1580" data-mp="7wiw2gu8wjqv">
      <PageHeader title={isAdmin ? 'Moj napredek' : 'Napredek'} subtitle="Samo tvoj teden – brez primerjanja z drugimi." onBack={isAdmin ? () => openSub(null) : undefined} backLabel="Danes" data-id="element-1581" data-mp="24r58tk74w5l5" />
      <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_340px] lg:gap-8" data-id="element-1582" data-mp="29s2yehuh41wo">
        <div className="min-w-0 space-y-8" data-id="element-1583" data-mp="e4h01ruk28rj">
          <WeekPlanCard memberId={viewer.id} data-id="element-1584" data-mp="9bxmuvzs5fn9" />
          {child && <RewardsSection memberId={viewer.id} data-id="element-1585" data-mp="9acr531qbqnt" />}
          <TimeLogSection memberId={viewer.id} data-id="element-1586" data-mp="4cl0sdgqgclq" />
        </div>
        <aside className="order-first space-y-4 lg:order-none" data-id="element-1587" data-mp="4b03wh6y4hkp">
          {child && <AllowanceCard memberId={viewer.id} data-id="element-1588" data-mp="3vlgzemf0d750" />}
          {child && <GoodiesJarCard memberId={viewer.id} data-id="element-1589" data-mp="x2a2yu56iiox" />}
          <GoalCard data-id="element-1590" data-mp="wzxmklf2kgdz" />
        </aside>
      </div>
    </div>;
}